
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hjaelp/faq",
      function () {
        return require("private-next-pages/hjaelp/faq/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hjaelp/faq"])
      });
    }
  